<template>
  <div class="project-form-package" ref="projectRef">
    <template v-if="tempFormConf.showItem == 'start'">
      <div
        v-if="getBackgroundStyle && getFormTheme.enable"
        :style="getBackgroundStyle"
        class="define-theme-form"
        @click="getShowModule('project')"
      >
        <!-- <div class="define-theme-form-start" @click="getShowModule('project')"></div> -->
      </div>
      <div v-else :style="getBackgroundStyle" class="project-form-main">
        <!-- 答题开始页面  -->
        <div class="flex-column project-form-start">
          <div style="width: 100%">
            <div v-if="getFormTheme.showTitle" class="title-box" v-html="formConf.title" />
          </div>
          <div class="posi-relative">
            <img class="form-start-icon" src="@/assets/images/form-bg2.png" alt="" />
            <img class="describe-html-icon" src="@/assets/images/form-bg3.png" alt="" />
            <div v-show="getFormTheme.showDescribe" class="describe-html-content">{{ formConf.description }}</div>
          </div>
          <el-button type="primary" class="start-btn" @click="getShowModule('project')">开始答题</el-button>
        </div>
      </div>
    </template>
    <!-- 答题区域start -->
    <div
      :style="getAnswerBackgroundStyle"
      class="project-form-main flex-column"
      v-if="tempFormConf.showItem == 'project'"
    >
      <div class="svg-list" v-if="showSvgList">
        <span class="svg-list-item svg-list-item-yellow"><svg-icon name="yellow" /></span>
        <span class="svg-list-item svg-list-item-green"><svg-icon name="green" /></span>
      </div>
      <div v-if="showUserLogo" style="margin-bottom: 8%">
        <img :src="showUserLogo" class="define-logo-img" />
      </div>
      <div class="project-form-item" :class="getFormMainClass">
        <div class="project-form-item-content">
          <div v-if="getFormTheme.logoImg" :style="{ textAlign: getFormTheme.logoPosition }">
            <img :src="getFormTheme.logoImg" class="logo-img" />
          </div>

          <el-image v-if="getFormTheme.headImgUrl" :src="getFormTheme.headImgUrl" style="width: 100%" />
          <!-- <div v-if="getFormTheme.showTitle" class="form-name-text" style="text-align: center" v-html="formConf.title" /> -->
          <template v-if="!pageSettingData.pageShowMore">
            <div class="progress-bar-wrap">
              <div class="progress-bar-inner">
                <div class="progress-bar">
                  <div class="progress-bar-bg" :style="{ width: bgwidth, background: getFormTheme.progressBarColor }" />
                </div>

                <div class="progress-num">{{ showCurrPage }} / {{ formConf.fields[0].totalPageNum }}</div>
              </div>
            </div>
          </template>
          <div v-if="!getAnswerBackgroundStyle" class="posi-relative el-svg">
            <span :class="['svg-star', { 'svg-star-morebt': pageSettingData.pageShowMore }]"
              ><svg-icon name="star"
            /></span>
            <span class="svg-circle"><svg-icon name="circle" /></span>
          </div>
          <parser
            v-if="startParser"
            :key="parserKey"
            ref="pageContent"
            class="p15"
            :form-conf="tempFormConf"
            :logic-trigger-item-list.sync="logicTriggerItemList"
            :page-form-model.sync="pageFormModel"
            @next="nextPage"
            @prev="prevPage"
            @submit="submit"
            :pageShowMore="pageSettingData.pageShowMore"
          />
        </div>
        <!-- <span>{{tempFormConf}} </span> -->
        <div v-if="tempFormConf && tempFormConf.formBtns" class="flex-center" style="width: 100%">
          <template v-if="showSubmitBtn">
            <el-button
              :style="getSubmitBtnStyle"
              :class="[
                { 'btn-fixed': !pageSettingData.pageShowMore },
                'submit-btn-form-item submit-btn-form-item-define'
              ]"
              type="primary"
              :loading="btnLoading"
              @click="submitFormBtn"
            >
              <span v-if="!getSubmitBtnStyle || tempFormConf.theme.answerPageSubButtonType === 1">
                {{ tempFormConf.theme && tempFormConf.theme.submitBtnText ? tempFormConf.theme.submitBtnText : '提交' }}
              </span>
            </el-button>
          </template>
          <el-button
            :class="[{ 'btn-fixed': !pageSettingData.pageShowMore }, 'submit-btn-form-item']"
            v-if="tempFormConf.resetBtn"
            @click="resetForm"
          >
            重置
          </el-button>
        </div>
      </div>
    </div>
    <!-- 答题区域end -->
    <!-- 答题结束页面 -->
    <template v-if="tempFormConf.showItem == 'end'">
      <div v-if="getBackgroundStyle && getFormTheme.enable" :style="getBackgroundStyle" class="define-theme-form"></div>
      <div :style="getBackgroundStyle" class="project-form-main flex-column" v-else>
        <div class="svg-list">
          <span class="svg-list-item svg-list-item-yellow"><svg-icon name="yellow" /></span>
          <span class="svg-list-item svg-list-item-green"><svg-icon name="green" /></span>
        </div>
        <div class="project-form-item project-form-end project-form-item-default">
          <div class="flex-column" style="align-items: center">
            <img class="form-end-img" src="@/assets/images/form-end.png" alt="" />
            <span>{{ pageSettingData.submitShowCustomPageContent || '提交成功' }}</span>
          </div>
          <span class="text-center support-text">{{ getDevSupport }} - 提供技术支持</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { deepClone } from '@/utils/index'
import Parser from './GenerateForm'
import _ from 'lodash'
import { getFormData, getFormSaveData, saveFormSaveData } from '@/utils/db'
import { isMobile } from '@/utils'
import { isObjectEmpty } from '@/utils/formatObject'

const bgImgMap = {
  start: 'startPageBackgroundPic',
  end: 'submitPagePic'
}

window.onload = function () {
  document.addEventListener('touchstart', (event) => {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', (event) => {
    event.preventDefault()
  })
}
export default {
  name: 'GenerateFormContainer',
  components: {
    Parser
  },
  props: {
    formConf: {
      type: Object,
      default() {
        return {
          fields: [],
          logicShowRule: {}, // 逻辑规则
          formKey: '', // 项目唯一标识
          formRef: 'elForm', // 表单 ref名称
          size: 'small',
          labelPosition: 'top',
          labelWidth: 100,
          formRules: 'rules',
          gutter: 15,
          disabled: false,
          span: 24,
          formBtns: true, // 提交按钮是否显示
          resetBtn: false, // 重置按钮是否显示
          submitBtnColor: '#409EFF',
          unFocusedComponentBorder: true,
          perPageFields: {}, // 当存在分页功能 每页的数据
          // 主题相关
          theme: {
            headImgUrl: '',
            logoImg: '',
            backgroundColor: '',
            backgroundImg: '',
            logoPosition: '',
            showTitle: true,
            submitBtnText: '提交',
            showSubmitBtn: false,
            showDescribe: true,
            showNumber: true, // 显示问题行号
            isShowItemQuestionNumber: false // 是否展示问题题号
          },
          showItem: 'start', //当前展示模块  start:开始答题页 project:答题页 end:答题结束页
          isPC: false
        }
      }
    },
    pageSettingData: {
      type: Object
    }
  },
  inject: ['formWriteSubmit', 'formConfig'],
  data() {
    return {
      // 默认主题
      defaultTheme: {
        headImgUrl: '',
        logoImg: '',
        backgroundColor: '',
        backgroundImg: '',
        logoPosition: '',
        showSubmitBtn: true,
        showTitle: true,
        showDescribe: true
      },
      startParser: true,
      // 临时表单存放表单数据
      pageFormModel: {},
      // 逻辑显示被触发的字段列表
      logicTriggerItemList: [],
      tempFormConf: {},
      // 全部字段 避免分页时fields 为当页字段
      allFields: [],
      parserKey: +new Date(),
      showCurrPage: 1,
      btnLoading: false
    }
  },
  computed: {
    getFormTheme() {
      let tempTheme = this.formConf.theme ? this.formConf.theme : this.defaultTheme
      // 自定义外观没有设置图片时，展示默认外观（默认展示标题/描述/按钮）
      if (tempTheme.enable) tempTheme = { ...tempTheme, ...this.defaultTheme }
      return tempTheme
    },
    bgwidth({ formConf, showCurrPage }) {
      console.log({ formConf, showCurrPage })
      const len = formConf.fields[0].totalPageNum || 0
      if (len === 0) return 0
      return (showCurrPage / len) * 100 + '%'
    },
    showPrevBtn({ formConf, showCurrPage }) {
      const len = formConf.fields?.length || 0
      if (len === 0) return false
      return showCurrPage !== 0
    },
    showNextBtn({ formConf, showCurrPage }) {
      const len = formConf.fields?.length || 0
      if (len === 0) return false
      return showCurrPage + 1 !== len
    },
    getBackgroundStyle() {
      const { theme, isPcOrMobile } = this.formConf

      if (!theme) {
        return ''
      }
      let style = {}
      // 默认外观
      if (!theme.enable) {
        if (theme.backgroundColor) {
          style.background = theme.backgroundColor
        }
        if (theme.backgroundImg) {
          style['background'] = 'url(' + theme.backgroundImg + ') no-repeat center / cover'
        }
      } else {
        // 自定义外观
        let paramskeySome = isMobile() ? 'Mobile' : 'Pc'
        if (isPcOrMobile) paramskeySome = isPcOrMobile
        let paramskey = bgImgMap[this.tempFormConf.showItem] + paramskeySome
        if (theme[paramskey]) {
          style['background'] = 'url(' + theme[paramskey] + ') no-repeat center / cover'
        }
      }
      return isObjectEmpty(style) ? '' : style
    },
    getAnswerBackgroundStyle() {
      const { theme, isPcOrMobile } = this.formConf
      let style = {}
      if (!theme) {
        return ''
      }
      // 默认外观
      if (!theme.enable) {
        if (theme.backgroundColor) {
          style.background = theme.backgroundColor
        }
        if (theme.backgroundImg) {
          style['background'] = 'url(' + theme.backgroundImg + ') no-repeat center / cover'
        }
      } else {
        // 答题页背景图
        if (theme.answerPageBackgroundType === 0) {
          let paramskeySome = isMobile() ? 'Mobile' : 'Pc'
          if (isPcOrMobile) paramskeySome = isPcOrMobile
          let paramskey = 'answerPageBackgroundPic' + paramskeySome

          if (theme[paramskey]) {
            style['background'] = 'url(' + theme[paramskey] + ') no-repeat center / cover'
          }
        } else {
          // 答题页背景色
          style.background = this.formConf.theme.answerPageBackgroundColor
        }
      }
      return isObjectEmpty(style) ? '' : style
    },
    showSvgList() {
      // 默认外观展示
      // 自定义外观 没有上传背景和背景色时展示
      const { theme, isPcOrMobile } = this.formConf
      if (!theme) {
        return true
      } else {
        if (theme.answerPageBackgroundType === 0) {
          let paramskeySome = isMobile() ? 'Mobile' : 'Pc'
          if (isPcOrMobile) paramskeySome = isPcOrMobile
          let paramskey = 'answerPageBackgroundPic' + paramskeySome
          if (!theme[paramskey]) return true
        } else {
          if (!theme.answerPageBackgroundColor) return true
        }
        return false
      }
    },
    // 自定外观logo
    showUserLogo() {
      // 默认外观展示
      // 自定义外观 没有上传背景和背景色时展示
      const { theme, isPcOrMobile } = this.formConf
      if (!theme) {
        return ''
      } else {
        let paramskeySome = isMobile() ? 'Mobile' : 'Pc'
        if (isPcOrMobile) paramskeySome = isPcOrMobile
        let paramskey = 'answerPageLogo' + paramskeySome
        return theme[paramskey]
      }
    },
    getDevSupport() {
      let support = localStorage.getItem('FORM-SUPPORT')
      return support ? support : '大头软件'
    },
    getFormPageCount() {
      return _.keys(this.formConf.perPageFields).length
    },
    showSubmitBtn() {
      const { theme } = this.formConf
      if (theme && theme.isDisableSubmitButton) {
        return false
      }
      return true
    },
    getSubmitBtnStyle() {
      const { theme, isPcOrMobile } = this.formConf
      if (!theme) return ''
      let style = {}
      if (theme.answerPageSubButtonType === 0) {
        let paramskeySome = isMobile() ? 'Mobile' : 'Pc'
        if (isPcOrMobile) paramskeySome = isPcOrMobile
        let paramskey = 'answerPageSubButtonPic' + paramskeySome
        if (theme[paramskey]) {
          style['background'] = 'url(' + theme[paramskey] + ') no-repeat center / cover'
        }
      } else {
        if (theme.answerPageSubButtonColor) style['background-color'] = `${theme.answerPageSubButtonColor} !important`
        if (theme.answerPageSubTextColor) style['color'] = theme.answerPageSubTextColor
      }
      console.log({ style })
      return JSON.stringify(style) === `{}` ? false : style
    },
    getFormMainClass() {
      let className = ''
      if (this.getAnswerBackgroundStyle) className = 'no-border'
      if (!this.getSubmitBtnStyle || this.tempFormConf.theme.answerPageSubButtonType === 1) {
        className = `${className} project-form-item-default`
      } else {
        className = `${className} project-form-item-define`
      }
      return className
    }
  },
  watch: {
    'formConfig.showItem': function (val) {
      if (val === 'end') this.tempFormConf.showItem = val
    }
  },
  beforeCreate() {
    // 插入 meta 标签
    const viewport = document.createElement('meta')
    viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
    viewport.name = 'viewport'
    document.getElementsByTagName('head')[0].appendChild(viewport)
    document.querySelector('body').className = 'project-body'
  },
  created() {
    this.tempFormConf = deepClone(this.formConf)
    // 分页序号存放
    this.tempFormConf.pageSeqNoObj = {}
    this.allFields = this.tempFormConf.fields
    // 分页取出每页数据合并
    if (_.keys(this.tempFormConf.perPageFields)) {
      let allFields = []
      _.values(this.tempFormConf.perPageFields).forEach((value, index) => {
        allFields = allFields.concat(value)
      })
      this.allFields = allFields
    }
    // 是否有上次未提交数据
    if (this.formConf.setting && this.formConf.setting.saveNotSubmitStatus) {
      let formModel = getFormData(this.formConf.formKey)
      if (formModel) {
        this.$confirm('检查到有上次未提交的数据，是否继续填写？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.pageFormModel = formModel
            this.parserKey = +new Date()
          })
          .catch(() => {})
      }
    }
    // 带入已提交的数据
    if (this.formConf.setting && this.formConf.setting.saveSubmitStatus) {
      let formModel = getFormSaveData(this.formConf.formKey)
      if (formModel) {
        this.$confirm('是否使用上次提交的数据再次填写？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.pageFormModel = formModel
            this.parserKey = +new Date()
          })
          .catch(() => {})
      }
    }
  },
  methods: {
    getShowModule(name = null) {
      this.$set(this.tempFormConf, 'showItem', name)
    },
    // 上一页
    prevPage(params) {
      if (params.page <= 1) {
        return
      }
      this.parserKey = +new Date()
      this.tempFormConf.pageSeqNoObj[params.page] = params
      this.tempFormConf.startSeqNo = this.tempFormConf.pageSeqNoObj[params.page - 1]?.startSeqNo
      this.switchPage(params.page - 1, params)
      // 如果页无有效显示内容 直接跳过
      if (!this.hasShowField()) {
        params.page = params.page - 1
        this.prevPage(params)
      }
    },
    nextPage(params) {
      console.log('page', params)
      if (params.page >= this.getFormPageCount) {
        return
      }
      this.tempFormConf.pageSeqNoObj[params.page] = params
      this.tempFormConf.startSeqNo = params.endSeqNo
      this.switchPage(params.page + 1, params)
      // 如果页无有效显示内容 直接跳过
      if (!this.hasShowField()) {
        params.page = params.page + 1
        this.nextPage(params)
        return
      }
      // 分页滚动到最顶部
      this.$nextTick(() => {
        const container = document.querySelector('.write-container')
        if (container) {
          container.scrollTop = 0
        }
      })
    },
    switchPage(page, params) {
      const { formModel } = params
      this.pageFormModel = formModel
      this.tempFormConf.formBtns = _.keys(this.formConf.perPageFields).length <= page
      this.tempFormConf.fields = _.get(this.formConf.perPageFields, page) || []
      this.tempFormConf.currentPage = page
      this.showCurrPage = page
      this.parserKey = +new Date()
    },
    // 是否有显示的字段
    hasShowField() {
      let hasShow = false
      // 过滤掉分页组件本身
      let fields = this.tempFormConf.fields.filter((item) => item.typeId !== 'PAGINATION')
      for (let field of fields) {
        //不是逻辑显示字段
        if (!field.logicShowField) {
          hasShow = true
        }
        if (_.indexOf(this.logicTriggerItemList, field.vModel) > -1) {
          return true
        }
      }
      return hasShow
    },
    submit(data) {
      const { formModel } = data
      try {
        if (this.formConf.setting && this.formConf.setting.saveSubmitStatus) {
          saveFormSaveData(formModel, this.formConf.formKey)
        }
      } catch (e) {
        console.log(e)
      }
      this.formWriteSubmit(data)
    },
    submitFormBtn() {
      this.$refs.pageContent.generateFormSubmit()
    }
  },
  destroyed() {
    clearTimeout()
  }
}
</script>

<style lang="scss">
@import '../../../assets/styles/elementui-mobile.scss';
@import '../../../assets/styles/project.scss';
</style>
